export function updateLink(to) {
  const link = location.origin + to;
  document.querySelector('link[rel="canonical"]').setAttribute('href', link);
  document.querySelector('meta[property="og:url"]').setAttribute('content', link);
}
